<template>
  <div id="healthcareProfForm" class="relative hidden">
    <title-w-star :title="t('workWithUs.healthcareProf')" titleColor="#603813" :starIconObj="{ componentName: 'shared', imgName: 'starIconGreen', imgFormat: 'svg' }" />
    <img src="@/assets/images/shared/starGroupIconLightBrownLeftSmall.svg" style="width: 7vw; top: 20%" class="absolute left-0 -z-10" />
    <!-- starGroup for Open Positions -->
    <img src="@/assets/images/shared/starGroupIconLightBrownLeftBig.svg" style="width: 9.5vw; top: 250%" class="absolute left-0 -z-10" />

    <div id="healthcareProfFormFrame" class="font-jost bg-grey-background m-14 p-20 rounded-3xl text-lg">
      <Form ref="healthcareProfForm" id="healthcareProfForm" @submit="sendMsg" :validation-schema="schema">
        <div class="flex space-x-14">
          <span class="w-1/3 flex items-center">
            <span>{{ t("workWithUs.firstName") }}*</span>
            <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="firstNameError">{{ firstNameError }}</span>
          </span>
          <span class="w-1/3 flex items-center">
            <span>{{ t("workWithUs.lastName") }}*</span>
            <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="lastNameError">{{ lastNameError }}</span>
          </span>
          <span class="w-1/3 flex items-center">
            <span>{{ t("workWithUs.category") }}*</span>
            <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="categoryError">{{ categoryError }}</span>
          </span>
        </div>
        <div class="flex space-x-14">
          <input v-model="firstName" type="text" name="firstName" class="border border-input-border rounded px-3 h-12 w-1/3" />
          <input v-model="lastName" type="text" name="lastName" class="border border-input-border rounded px-3 h-12 w-1/3" />
          {{ category }}
          <select name="category" id="category" v-model="category" class="border border-input-border rounded px-3 h-12 w-1/3" style="border-width: 1px">
            <option value="" disabled>{{ t("common.pleaseSelect") }}</option>
            <template v-for="(item, index) in workWithUsStore.form.categoryList" :key="'category' + index">
              <option :value="t(item)">{{ t(item) }}</option>
            </template>
          </select>
        </div>
        <div class="flex space-x-14 pt-10">
          <span class="flex items-center" style="width: 70%"
            ><span>{{ t("workWithUs.emailAddress") }}</span> <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="emailAddressError">{{ emailAddressError }}</span>
          </span>
          <span class="w-1/3 flex items-center"
            ><span>{{ t("workWithUs.mobile") }}*</span>
            <span class="text-red-500 xl:text-xs xl: font-bold pl-1" id="mobileError">{{ mobileError }}</span>
          </span>
        </div>
        <div class="flex space-x-14">
          <input v-model="emailAddress" type="text" name="emailAddress" class="border border-input-border rounded px-3 h-12" style="width: 70%" />

          <input v-model="mobile" type="text" name="mobile" class="border border-input-border rounded px-3 h-12 w-1/3" />
        </div>

        <!-- <button-util buttonType="submit" bgColor="#603813" label="workWithUs.contactUs" class="mt-10" /> -->
      </Form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHeaderStore } from "@/stores/header";
import { useWorkWithUsStore } from "@/stores/workWithUs";
import { computed, onMounted, ref, toRefs } from "vue";
import { useForm, useField } from "vee-validate";
import { object, string } from "yup";
import { useRouter } from "vue-router";
import { useCommonStore } from "@/stores/common";
import { useI18n } from "vue-i18n";

const headerStore = useHeaderStore();
const workWithUsStore = useWorkWithUsStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};

const phoneRegExp = /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;
// Define a validation schema
const schema = computed(() => {
  return object({
    firstName: string().required(t("workWithUs.firstNameRequired")),
    lastName: string().required(t("workWithUs.lastNameRequired")),
    category: string().required(t("workWithUs.categoryRequired")),
    emailAddress: string().email(),
    mobile: string().required(t("workWithUs.mobileRequired")).matches(phoneRegExp, t("workWithUs.mobileInvalid")),
  });
});
// Create a form context with validation schema
const { handleSubmit, isSubmitting, meta } = useForm({
  validationSchema: schema,
  initialValues: {
    firstName: "",
    lastName: "",
    category: "",
    emailAddress: "",
    mobile: "",
  },
});

const { value: firstName, errorMessage: firstNameError } = useField<string>("firstName");
const { value: lastName, errorMessage: lastNameError } = useField<string>("lastName");
const { value: category, errorMessage: categoryError } = useField<string>("category");
const { value: emailAddress, errorMessage: emailAddressError } = useField<string>("emailAddress");
const { value: mobile, errorMessage: mobileError } = useField<string>("mobile");

const sendMsg = handleSubmit(async (values, actions) => {
  //debugger;

  console.log("sendMsg");
  let detail = {
    contactEntryPoint: headerStore.routerName,
    firstName: firstName.value,
    lastName: lastName.value,
    category: category.value,
    emailAddress: emailAddress.value,
    mobile: mobile.value,
  };

  detail.message = "First Name: " + detail.firstName + "<br />" + "Last Name: " + detail.lastName + "<br />" + "Category: " + detail.category + "<br />" + "Email Address: " + detail.emailAddress + "<br />" + "Mobile: " + detail.mobile;

  //replace \n to <br> for new line
  var isSuccess = await workWithUsStore.workWithUs(detail);
  console.log("isSuccess?" + isSuccess);
  if (isSuccess) actions.resetForm();
});
</script>